import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './nuvance-top-bar.global.pcss?inline';
import innerStyles from './nuvance-top-bar.inner.pcss?inline';

/**
 * The Nuvance Top Bar component
 * @element nuvance-top-bar
 * @slot - The default slot for this element breadcrumb, location and language.
 * @slot logo - Named slot for logo content.
 * @slot search - Named slot for Search content.
 * @slot menu-toggle - Named slot for mobile menus toggle button.
 */
@customElement('nuvance-top-bar')
export class NuvanceTopBar extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });

  @property({
    type: Boolean,
    reflect: true,
    attribute: 'theme-dark',
  })
  themeDark = false;

  render(): TemplateResult {
    return html`
      <div class="top-bar">
        <slot name="logo"></slot>
        <slot name="main"></slot>
        <slot name="search"></slot>
        <slot name="menu-toggle"></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nuvance-top-bar': NuvanceTopBar;
  }
}
